import { render, staticRenderFns } from "./VersionDetails.vue?vue&type=template&id=7eee60ce&scoped=true"
import script from "./VersionDetails.vue?vue&type=script&lang=js"
export * from "./VersionDetails.vue?vue&type=script&lang=js"
import style0 from "./VersionDetails.vue?vue&type=style&index=0&id=7eee60ce&prod&lang=css"
import style1 from "./VersionDetails.vue?vue&type=style&index=1&id=7eee60ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eee60ce",
  null
  
)

export default component.exports